import { inProductionEnv } from '@/helpers/global.helpers'

export const SMARTSUPP_ES = '2208bb3618a649a6e2e120bf7daf45d0e18594af'
export const SMARTSUPP_MX = '75e63a8149f1eca528b1aca1f4a789c4b8fc115a'
export const OPENPAY_API_KEY = inProductionEnv ? 'pk_a5d322d100964e819ed5346f3837f6f0' : 'pk_b5acc0902c924292821de794c91f6fd3'
export const OPENPAY_ID = inProductionEnv ? 'mumpqe6et4bx9b5uethf' : 'mmzcbm6dlgqc6n4ikogz'
export function getSmartsuppKey () {
    return window.location.href.includes('.mx') ? SMARTSUPP_MX : SMARTSUPP_ES
}


// WEBPACK FOOTER //
// ./src/constants/vendorKeys.js